import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";

const Visitors = ({ prevStep, nextStep }) => {
  const rules = [
    "You can have visitors to the home as agreed by your mums and social worker",
    "Any negative behavior displayed from yourself or visitors, the visit will be ended and a review of future contact will be discussed",
    "There may be other visitors that attend the home like the regulation 44 visitor, Ofsted, professional to meet the manager, the maintenance team or any other work people required if needed. Every visitor is to be treated with respect and a kind approach",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />
        <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
          House Rules
        </Typography>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Visitors
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Visitors are allowed with prior approval, and their behavior must align with the house rules."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={1} mr={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Visitors;
